export const enum Language {
  de = 'de',
  en = 'en',
  nl = 'nl',
  fr = 'fr'
}
